import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Main from "./routes/main";
import AboutMe from "./routes/aboutme";
import Projects from "./routes/projects";
import SuperSimpleScrum from "./routes/supersimplescrum";
import WhyTypeTwice from "./routes/whytwice";
import Experience from "./routes/experience";
import CDN from "./routes/cdn";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        {/* <Route path="/aboutme" element={<AboutMe />} /> */}
        <Route path="/experience" element={<Experience />} />
        {process.env.REACT_APP_ENV !== "prod" && <Route path="/cdn" element={<CDN />} />}
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/supersimplescrum" element={<SuperSimpleScrum />} />
        <Route path="/projects/whytwice" element={<WhyTypeTwice />} />
      </Routes>
    </Router>
  );
}

export default App;
